// GA4 Standard Ecommerce Events
// These use the exact event names GA4 expects for
// Purchase Journey and Checkout Journey reports.

/** Push a standard GA4 ecommerce event via dataLayer.
 * Wrapped in try/catch because dataLayer.push runs GTM tags synchronously
 * — a tag with a Zod validator that throws would bubble into the caller. */
const pushEcommerceEvent = (eventName: string, params: Record<string, unknown>) => {
  if (typeof window === 'undefined' || !window.dataLayer) return;
  try {
    // Clear previous ecommerce data per GA4 docs
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      ecommerce: params,
    });
  } catch (err) {
     
    console.warn(`[ga4Ecommerce] ${eventName} dataLayer.push threw, swallowed:`, err);
  }
};

/** GA4: view_item — user views a coin pack on pricing/buy page */
export const ga4ViewItem = (packName: string, price: number, coins: number) => {
  pushEcommerceEvent('view_item', {
    currency: 'EUR',
    value: price,
    items: [{
      item_id: `coins_${coins}`,
      item_name: `${coins} Coins - ${packName}`,
      price,
      quantity: 1,
      item_category: 'coins',
    }],
  });
};

/** GA4: begin_checkout — user clicks "Purchase" and Stripe session is created */
export const ga4BeginCheckout = (packName: string, price: number, coins: number) => {
  pushEcommerceEvent('begin_checkout', {
    currency: 'EUR',
    value: price,
    items: [{
      item_id: `coins_${coins}`,
      item_name: `${coins} Coins - ${packName}`,
      price,
      quantity: 1,
      item_category: 'coins',
    }],
  });
};

/** GA4: purchase — user returns from Stripe with successful payment */
export const ga4Purchase = (transactionId: string, price: number, coins: number) => {
  pushEcommerceEvent('purchase', {
    transaction_id: transactionId,
    currency: 'EUR',
    value: price,
    items: [{
      item_id: `coins_${coins}`,
      item_name: `${coins} Coins`,
      price,
      quantity: 1,
      item_category: 'coins',
    }],
  });
};
